export const REPORTS_NAMESPACE = 'reports'
export const DOWNLOAD_TYPE_PREFIX = `${REPORTS_NAMESPACE}/downloadWithProgress`
